'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WebResults = require('./components/WebResults.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebResults).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/web-results/components/web-results/index.js
// module id = 987
// module chunks = 1